import React, { useCallback, useContext, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { UserContext } from 'context/user'
import AuthLayout from 'layouts/authLayout'
import routes from 'routes'
import { ForgotPasswordForm } from 'components/Auth/ForgotPasswordForm'
import { CreateNewPasswordForm } from 'components/Auth/CreateNewPasswordForm'

const sx = {
  root: {
    maxWidth: theme => theme.spacing(50),
  }
}

export const ForgotPassword = () => {
  const user = useContext(UserContext)
  const [currentStep, setCurrentStep] = useState(0)

  const onNextStep = useCallback(() => setCurrentStep(currStep => currStep + 1), [])

  if (user) {
    return <Navigate to={routes.home} />
  }

  return (
    <AuthLayout bgType="signIn">
      <Box sx={sx.root} className={`customAuthInput`}>
        {currentStep === 0 && <ForgotPasswordForm onNextStep={onNextStep} />}
        {currentStep === 1 && <CreateNewPasswordForm />}
      </Box>
    </AuthLayout>
  )
}
